var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"add-layer-icon"},[_c('q-icon',{staticClass:"add-layer-icon__layers",attrs:{"name":"layers","size":"1em"}}),_c('q-icon',{staticClass:"add-layer-icon__add",attrs:{"name":"add","size":"0.45em"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }